import React from 'react';

import {
  FormProviderNewPrice,
  Paragraph,
  SubtitleSecondary,
} from '@components/index';

import { Container, Group } from './styles';

interface IProps {
  myStep: number;
  currentStep: number;
  changeStep(newStep: number, willChangeHistory?: boolean): void;
}

const StepPrice: React.FC<IProps> = ({ currentStep, changeStep }) => {
  return (
    <Container>
      <SubtitleSecondary textAlign="start" nameColor="black">
        Preços
      </SubtitleSecondary>
      <Paragraph
        textAlign="start"
        nameColor="black"
        opacity={0.5}
        fontWeight={500}
      >
        Informe a tabela de preços dos serviços selecionados anteriormente
      </Paragraph>
      <Group>
        <FormProviderNewPrice
          forNewProviderPrice={{
            advanceStep: () => {
              changeStep(currentStep + 1);
            },
          }}
        />
      </Group>
    </Container>
  );
};

export default StepPrice;
